import { RefreshCw, ShieldAlert } from "lucide-react";

import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import { ColocaAlert } from "@/shared/components/feedback/ColocaAlert";
import useTranslations from "@/shared/lang/useTranslations";

import { useDispersions } from "../../hooks/useDispersions";

/**
 * Error state of the verified-clients (KYC) fetch, shared by every recipient panel. That list is the ONLY KYC
 * enforcement of the dispersal flow (the backend does not re-check at dispersal), so while it is unknown the
 * step-2 gate fails CLOSED — this alert tells the user why Continue is blocked and offers the retry that
 * unblocks it. Renders nothing when there is no error (loading or INTERNAL users without the fetch).
 */
export function ClientKycUnavailableAlert() {
  const { clientKycError, clientKycLoading, fetchVerifiedClientIds } = useDispersions();
  const { t } = useTranslations("dispersions");

  if (clientKycError === null) return null;

  return (
    <ColocaAlert
      aria-live="polite"
      variant="destructive"
      icon={ShieldAlert}
      text={t("client_kyc_unavailable_note")}
      actions={
        <ColocaButton
          size="sm"
          variant="destructive"
          icon={RefreshCw}
          loading={clientKycLoading}
          onClick={() => fetchVerifiedClientIds()}
        >
          {t("client_kyc_retry_button")}
        </ColocaButton>
      }
    />
  );
}
